/**
 * 
 */
class WMUFieldRecaptcha {

	/**
	 * @type HTMLFormElement
	 */
	formElement = null;

	/**
	 * @type HTMLInputElement
	 */
	inputElement = null;

	/**
	 * @type String
	 */
	key = '';

	/**
	 * 
	 * @param {HTMLInputElement} inputElement 
	 */
	constructor( inputElement )
	{
		this.inputElement = inputElement;
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		if ( ! this.inputElement )
		{
			console.warn( 'WMUFieldRecaptcha: Given input is not a valid one', this.inputElement );
			return;
		}

		this.key = this.inputElement.getAttribute( 'data-key' );

		if ( ! this.key )
		{
			console.warn( 'WMUFieldRecaptcha: Given input don\'t seems to have a valid data-key attribute', this.inputElement );
			return;
		}

		this.formElement = this.inputElement.closest( 'form' );

		if ( ! this.formElement )
		{
			console.warn( 'WMUFieldRecaptcha: Unable to find the form for the given input', this.inputElement );
			return;
		}

		this.onFormSubmit = this.onFormSubmit.bind( this );
		this.formElement.addEventListener( 'submit', this.onFormSubmit );
	}

	/**
	 * 
	 */
	onFormSubmit( event )
	{
		event.preventDefault();
		event.stopImmediatePropagation();

		grecaptcha.ready( () =>
		{
			grecaptcha.execute( this.key, { action: 'submit' } ).then( ( token ) =>
			{
				this.inputElement.value = token;
				this.formElement.removeEventListener( 'submit', this.onFormSubmit );
				this.formElement.requestSubmit();
			} );
		} );
	}

}

export default WMUFieldRecaptcha;